/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createContext } from 'react';

const initialContext = {
    isReady: false,
    isPopUpOpen: false,
    verifyScopeExist: () => {},
    handlePopUpFocus: () => {},
    loginByRedirect: () => {},
    loginByAuth0PopUp: () => {},
    logout: () => {},
    getAccessTokenSafely: () => {},
};

let AuthContext = createContext(initialContext);

// Use context set in mbp-pwa-ui app
if (typeof window !== 'undefined' && window.mbpAuth && window.mbpAuth.AuthContext) {
    AuthContext = window.mbpAuth.AuthContext;
}

export default AuthContext;
